export const QUARTER_LABELS = ['1 квартал', '2 квартал', '3 квартал', '4 квартал'] as const;
